import { Button, ButtonProps } from '@chakra-ui/react'
import React from 'react'

interface PaginationItemProps {
  number: number
  isCurrent?: boolean
  onPageChange?: (page: number) => void
  buttonProps?: ButtonProps
}

export default function PaginationItem({
  isCurrent = false,
  number,
  buttonProps,
  onPageChange,
}: PaginationItemProps) {
  if (isCurrent) {
    return (
      <Button
        size="sm"
        fontSize="xs"
        {...buttonProps}
        width="4"
        disabled
        _disabled={{
          bgColor: '#9e59de',
          cursor: 'default',
        }}
        _hover={{ bg: '#9451d3' }}
      >
        {number}
      </Button>
    )
  }
  return (
    <Button
      size="sm"
      fontSize="xs"
      {...buttonProps}
      bgColor="gray.700"
      _hover={{ bg: '#9451d3' }}
      _active={{ bg: '#9451d3' }}
      onClick={() => onPageChange!(number)}
    >
      {number}
    </Button>
  )
}
